export default "__VITE_PUBLIC_ASSET__52e5d826__"